import AppForceUpdate from './AppForceUpdate';

export default AppForceUpdate;
